import { useQuery, useQueryClient } from 'react-query';
import { useState } from 'react';
import PlusCircle from '../../SharedComponents/Svg/PlusCircle';
import PecnilAlt from '../../SharedComponents/Svg/PencilAlt';
import Home from '../../SharedComponents/Svg/Home';
import ChevronRight from '../../SharedComponents/Svg/ChevronRight';
import Loading from '../../SharedComponents/Loading';
import ChevronLeft from '../../SharedComponents/Svg/ChevronLeft';
import { deleteNewsLetter, getNewsLetters } from './ApiNewsLetter';
import DeleteNewsLetter from './DeleteNewsLetter';
import AddNewsLetter from './AddNewsLetter';
import { Link } from 'react-router-dom';
import EditNewsLetter from './EditNewsLetter';
import DownloadNewsLetter from './DownloadNewsLetter';
import BreadCrumbs from '../../SharedComponents/BreadCrumbs';
import { useTranslation } from 'react-i18next';
import TablePagination from '../../SharedComponents/TablePagination';
import TableSearch from '../../SharedComponents/TableSearch';

export default function NewsLetters() {
  const [entries, setEntries] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [languageId, setLanguageId] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLanguage, setSearchlanguage] = useState(0);
  const { t, i18n } = useTranslation();
  const onSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
    setSearchlanguage(languageId);
  };

  let initialState = {
    pageNumber: pageNumber,
    pageSize: entries,
    isPaging: true,
    langId: 0,
    isSearch: searchTerm ? true : false,
    searchFilter: {
      langId: searchLanguage,
      term: searchTerm,
    },
  };
  const { data, isLoading, isError } = useQuery(['newsLetters', initialState], getNewsLetters, {
    staleTime: 99900,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    onSuccess: (data) => {
      pagination(data);
    },
  });
  const [paginationCount, setPaginationCount] = useState([]);

  function pagination(data) {
    let paginationCount = [];
    for (var i = 1; i <= data.paginationResult.numberOfPages; i++) {
      paginationCount.push(i);
    }
    setPaginationCount(paginationCount);
  }

  // to control how many rows to show in table
  const onChangeEntries = (e) => {
    setEntries(e.target.value);
  };

  const tabltHeader = [{ title: t('title') }, { title: t('OPTIONS'), className: 'w-64' }];

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch(e);
    }
  };
  return (
    <>
      <header className="flex justify-between items-center">
        <BreadCrumbs to="/newsletters" name={t('News Letters')} />
        <div>
          <AddNewsLetter />
        </div>
      </header>
      <div className="my-6">
        <h2 className="text-2xl font-bold">{t('News Letters')}</h2>
      </div>
      {/* Table */}
      <div className="bg-white rounded border shadow-md">
        <div className="flex justify-between relative items-center px-6 py-6">
          <TableSearch onChangeEntries={onChangeEntries} entries={entries} onSearch={onSearch} />
          <div className="flex  items-center transform -translate-y-3  relative z-10 ">
            <DownloadNewsLetter />
          </div>
          <hr className="border w-full absolute top-0 left-0 z-0 mt-16" />
        </div>
        {isLoading && (
          <div className="relative bg-white h-72">
            <Loading />
          </div>
        )}
        {isError && 'loading'}
        {data && (
          <div className="flex flex-col">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className=" overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y-2 divide-gray-200">
                    <thead className=" text-sm font-bold text-black">
                      <tr>
                        {tabltHeader.map((e) => {
                          return (
                            <th
                              key={e.title}
                              scope="col"
                              className={`px-6 py-3 ${
                                i18n.language === 'en' ? 'text-left' : 'text-right'
                              }    uppercase `}
                            >
                              {e.title}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 relative text-base text-darkgray font-normal">
                      {data &&
                        data.data &&
                        data?.data
                          ?.sort((a, b) => (a.id < b.id ? 1 : -1))
                          .map((newsletter) => {
                            return (
                              <tr key={newsletter.id} className="">
                                <td className="px-6 py-4 whitespace-nowrap">
                                  {newsletter.email}
                                  {/* <div className=' '>
                                {newsletter.pgPageLngs[0]?.title}
                              </div> */}
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap flex items-center space-x-2">
                                  <EditNewsLetter newsletter={newsletter} />
                                  <DeleteNewsLetter id={newsletter.id} />
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </table>
                  <TablePagination
                    data={data}
                    paginationCount={paginationCount}
                    setPageNumber={setPageNumber}
                    pageNumber={pageNumber}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
